import React from "react";

import { Navbar, Container, Row, Col }
    from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.css";

import "./App.css";

import BadgeRegistration from
    "./components/badge-registration.component";

import banner from './assets/high-res-banner.png';

const FACILITY = 'rensselaer'; //process.env.REACT_APP_INTELLIO_FACILITY;
const FACILITY_LOGO_PATH = `/facility-logos/facility-${FACILITY}.png`;

function NavbarHeader() {
    return (
        <Navbar sticky="top" bg="light" className="bg-body-tertiary">
            <Navbar.Brand>
                <img
                    src={banner} 
                    style={{ maxHeight: '5vh' }}
                    className="d-inline-block align-center"
                    alt="Intelligent Observation"
                />
            </Navbar.Brand>
            <Navbar.Collapse className="justify-content-end">
            <Navbar.Brand> Badge Registration </Navbar.Brand>
            </Navbar.Collapse>

        </Navbar>
    );
};

const App = () => {
    return (
        <div>
            <NavbarHeader/>
            <Container>
                <Row>
                    <Col>
                    <div className="centered">
                        <img src={FACILITY_LOGO_PATH} alt="Facility" style={{ maxHeight: '5vh' }}/>
                    </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <BadgeRegistration></BadgeRegistration>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default App;
